import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NumberDisplay from '../number-display';

import { showRequestFeedbackWindowForObject } from '../request-feedback-manager/actions';
import { requestEditWinLossOpportunityFeedbacks } from '../../modules/Dashboard/DashboardActions';

class Renderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.showRequestFeedbackWindow = this.showRequestFeedbackWindow.bind(this);
  }

  showRequestFeedbackWindow(e) {
    e.preventDefault();
    const { value } = this.props;
    if (!value || value === 0) {
      this.props.dispatch(requestEditWinLossOpportunityFeedbacks(this.props.data, this.props.isAccount));
    } else {
      this.props.dispatch(showRequestFeedbackWindowForObject(this.props.data, this.props.isAccount));
    }
  }

  render() {
    const { value, clickable, data } = this.props;

    let displayComp = value;
    if (!data) {
      return null;
    }
    if (value === null || value === undefined) {
      displayComp = (<em className="text-muted">N/A</em>);
    } else if (value === 0) {
      displayComp = (<span>no requests</span>);
    } else {
      displayComp = (<NumberDisplay value={value} precision={0} suffix="request" suffixIsUnit />);
    }
  
    if (clickable) {
      return (
        <a href="" onClick={this.showRequestFeedbackWindow}>
          {displayComp}
        </a>
      );
    }
    return displayComp;
  }
}


Renderer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.shape({}).isRequired,
  value: PropTypes.number,
  clickable: PropTypes.bool,
  isAccount: PropTypes.bool,
};
Renderer.defaultProps = {
  value: null,
  clickable: true,
  isAccount: false,
};
function mapStateToProps() {
  return {
  };
}
export default connect(mapStateToProps, null, null, { forwardRef: true })(Renderer);
